import { DisabledPrompt, Link } from "@bcm-dev/bcms-vite";
import React from 'react';
import './styles.css';

/**
 * @function MobileManageRecipientAccountsTable
 * @return {React.Component}
 * @exported true
 * @description A mobile list for manage recipient accounts.
 */

export default function MobileManageRecipientAccountsTable(props) {
  const accounts = props.accounts ?? [];
  const rows = accounts.reduce((acc, account) => {
    acc.push(
      <MobileManageRecipientAccountsRow key={ account.id } account={ account }/>
    );
    return acc;
  }, []);
  
  return(
    <div className="mobile-manage-recipient-accounts-table">
        { rows }
    </div>
  );
}

/**
 * @function MobileManageRecipientAccountsRow
 * @return {React.Component}
 * @exported false
 * @description A mobile row link for a recipient account.
 */

function MobileManageRecipientAccountsRow(props) {
  const account = props.account ?? {};
  const label = `${ account.nickname } - ${ account.number }`;

  return (
    <div className="mobile-manage-recipient-accounts-row">
      <DisabledPrompt>
        <Link dataPoint={ `Unlinked_Transfer_Accounts_Account_Link_${ account.id }` }>
          { label }
        </Link>
      </DisabledPrompt>
    </div>
  );
}
